import { TranslationMap } from '@trimble-gcs/i18n-types';

export function projectUsageTableTranslations() {
  return {
    projectId: {
      text: $localize`:@@config.projectUsageTable.header.projectId:Id`,
      desc: 'Header text for the project id column.',
    },
    projectName: {
      text: $localize`:@@config.projectUsageTable.header.projectName:Name`,
      desc: 'Header text for the project name column.',
    },
    usage: {
      text: $localize`:@@config.projectUsageTable.header.usage:Usage`,
      desc: 'Header text for the column displaying the project storage used.',
    },
    notMember: {
      text: $localize`:@@config.projectUsageTable.notMember.text:Not a project member`,
      desc: 'Text shown in place of the project name when the user does not have access to the project.',
    },
    projectLink: {
      tooltip: {
        text: $localize`:@@config.projectUsageTable.projectLink.tooltip:Open project in a new tab`,
        desc: 'Tooltip text on the link to open the project in a new tab.',
      },
    },
  } satisfies TranslationMap;
}
